/// <reference types="./overview.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $guards from "../../../../common/common/guards.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $dropdown from "../../../../ds/ds/components/dropdown.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import * as $model from "../../../data/model.mjs";
import * as $computed from "../../../data/model/computed.mjs";
import * as $state from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $route from "../../../data/route.mjs";
import * as $projects_table from "../../../frontend/view/components/projects_table.mjs";
import * as $tab_bar from "../../../frontend/view/components/tab_bar.mjs";
import { toList, prepend as listPrepend } from "../../../gleam.mjs";

function tab(model, route) {
  let computed = $bright.computed(model);
  let _block;
  if (route instanceof $route.Projects) {
    let $ = route[0];
    if ($ instanceof $route.OnGoing) {
      _block = new Some(
        [$icons.edit_line(), "Ongoing", computed.projects_count.ongoing],
      );
    } else if ($ instanceof $route.Previous) {
      _block = new Some(
        [$icons.check(), "Previous", computed.projects_count.finished],
      );
    } else {
      _block = new None();
    }
  } else {
    _block = new None();
  }
  let content = _block;
  if (content instanceof Some) {
    let icon = content[0][0];
    let text = content[0][1];
    let count = content[0][2];
    let counter = ((text + " (") + $int.to_string(count)) + ")";
    let _pipe = $tab_bar.tab(
      route,
      toList([$icons.small(icon), $el.text(counter)]),
    );
    return $tab_bar.disabled(_pipe, count === 0);
  } else {
    return $tab_bar.none();
  }
}

function create_proposal(model) {
  let state = $bright.state(model);
  let user = $state.current_user(state);
  let _block;
  let _pipe = $option.map(user, $guards.proposal_create);
  let _pipe$1 = $option.unwrap(_pipe, false);
  let _pipe$2 = $bool.negate(_pipe$1);
  _block = $dropdown.disabled(_pipe$2);
  let disabled = _block;
  let min_width = $css.class$(toList([$css.min_width($length.px(150))]));
  return $tab_bar.action(
    $l.row(
      toList([$l.flex("1"), $l.justify("end")]),
      toList([]),
      toList([
        (() => {
          let _pipe$3 = $dropdown.dropdown(
            (var0) => { return new $msg.UserSelectedCreation(var0); },
            toList([
              disabled,
              $dropdown.placeholder("Add"),
              $dropdown.panel_right(),
              $dropdown.input_class(
                $css.class$(
                  toList([
                    $css.compose($button.classes.primary()),
                    $css.selector(
                      " > *",
                      toList([
                        (() => {
                          let _pipe$3 = $css.color($colors.light.text_white);
                          return $css.important(_pipe$3);
                        })(),
                      ]),
                    ),
                  ]),
                ),
              ),
            ]),
            listPrepend(
              (() => {
                let _pipe$3 = $dropdown.choice("Project", new $msg.NewProject());
                let _pipe$4 = $dropdown.with_icon(_pipe$3, $icons.folder());
                return $dropdown.with_class(_pipe$4, min_width);
              })(),
              (() => {
                let $ = $list.is_empty(state.projects);
                if ($) {
                  return toList([]);
                } else {
                  let _pipe$3 = $dropdown.choice(
                    "Proposal",
                    new $msg.NewProposal(),
                  );
                  let _pipe$4 = $dropdown.with_icon(_pipe$3, $icons.file());
                  let _pipe$5 = $dropdown.with_class(_pipe$4, min_width);
                  return $list.wrap(_pipe$5);
                }
              })(),
            ),
          );
          return $el.map(_pipe$3, (var0) => { return new $msg.Proposal(var0); });
        })(),
      ]),
    ),
  );
}

function select_projects(model) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  let $ = state.route;
  if ($ instanceof $route.Projects) {
    let $1 = $[0];
    if ($1 instanceof $route.OnGoing) {
      return computed.projects.ongoing;
    } else if ($1 instanceof $route.Previous) {
      return computed.projects.finished;
    } else {
      return toList([]);
    }
  } else {
    return toList([]);
  }
}

export function view(model) {
  let state = $bright.state(model);
  let user = $state.current_user(state);
  let _block;
  let _pipe = $option.map(user, $guards.edit_proposal);
  _block = $option.unwrap(_pipe, false);
  let proposals_editable = _block;
  return $l.fragment(
    toList([
      $tab_bar.tab_bar(
        toList([
          tab(model, new $route.Projects(new $route.OnGoing())),
          tab(model, new $route.Projects(new $route.Previous())),
          create_proposal(model),
        ]),
      ),
      $projects_table.table(
        new $projects_table.Props(
          user,
          state.proposals.more_proposal_opened,
          new $projects_table.ShowMenu(),
          select_projects(model),
          state.opened_projects,
          proposals_editable,
          state.loading.proposals || $option.is_none(user),
          state.route,
          state.organization.users,
        ),
      ),
    ]),
  );
}
